import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import Notification from "../components/UI/Notification";
import NavBarMenu from "./NavBarMenu";
import { getTokenInfo, validateToken } from "../utils/Guard";

const BaseLayout = () => {
  const notification = useSelector((state) => state.ui.notification);
  const location = useLocation();
  const isValid = validateToken(location.pathname);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (
      userInfo !== undefined &&
      userInfo !== null &&
      userInfo.TemporalPassword !== null &&
      userInfo.TemporalPassword !== undefined &&
      userInfo.TemporalPassword === "True" &&
      !location.pathname.includes("auth")
    ) {
      window.location.href = "/auth/changePassword/" + userInfo.UserId;
    }
  });

  useEffect(() => {
    if (
      !location.pathname.includes("home") &&
      !location.pathname.includes("charges") &&
      !location.pathname.includes("departments") &&
      // !location.pathname.includes("country") &&
      !location.pathname.includes("organization") &&
      // !location.pathname.includes("documenttype") &&
      // !location.pathname.includes("permissions") &&
      // !location.pathname.includes("assignpermissions") &&
      !location.pathname.includes("users") &&
      // !location.pathname.includes("status") &&
      !location.pathname.includes("sign") &&
      !location.pathname.includes("auth") &&
      isValid
    ) {
      window.location.href = "/home";
    } else if (
      !isValid &&
      (location.pathname.includes("home") ||
        location.pathname.includes("charges") ||
        location.pathname.includes("departments") ||
        // location.pathname.includes("country") ||
        location.pathname.includes("organization") ||
        // location.pathname.includes("documenttype") ||
        // location.pathname.includes("permissions") ||
        // location.pathname.includes("assignpermissions") ||
        // location.pathname.includes("users") ||
        // location.pathname.includes("status") ||
        location.pathname.includes("sign"))
    ) {
      window.location.href = "/login";
    }
  }, [isValid, location.pathname]);

  return (
    <>
      {notification && (
        <Notification
          status={notification.status}
          title={notification.title}
          message={notification.message}
        />
      )}
      {!isValid && <Outlet />}
      <div>
        {isValid && (
          <>
            <NavBarMenu />
            <Outlet />
          </>
        )}
      </div>
    </>
  );
};
export default BaseLayout;
